import { Input } from 'antd';
const { Search } = Input;
import { useStandard } from '../../hook/useHook';
import { useState } from 'react';

export default function Index(props) {
    const { setSearchVal } = useStandard();
    const [val, setVal] = useState("");
    const onSearch = (val) => {
        setSearchVal((prev) => ({ ...prev, searchWord: val }))
    }
    return (
        <Search
            allowClear
            enterButton
            style={{ width: 400 }}
            onSearch={onSearch}
            value={val}
            onChange={(e) => setVal(e.target.value)}
        />
    );
}
